import { useField, useFormikContext } from 'formik';
import React from 'react';
import { useState } from 'react';
import * as styles from './input.module.sass';
import classNames from 'classnames';
import { Icon } from '../../atoms/icon';
import { Size } from '../../enums/size';
import InputMask from 'react-input-mask';
import { InputProps } from './props.type';
import { FieldWrapper } from '../FieldWrapper/FieldWrapper';


export const Input = React.memo((props: InputProps) => {
  const {
    name,
    type = 'text',
    placeholder = '',
    inputClassName = '',
    disabled = false,
    wrapperClassName,
    labelClassName,
  } = props;
  const [visible, setVisible] = useState(false);
  const [field, meta, helper] = useField(name);
  const { form_element, input_wrapper } = styles;

  const toggleVisibleClickHandler = () => {
    setVisible(oldVal => !oldVal);
  };

  const inputChangeHandler = async (event: React.ChangeEvent<HTMLInputElement>) => {
      helper.setTouched(true, true);
      helper.setValue(event.target.value);
  };

  const renderInput = () => {
    if (props.mask) {
      return (
        <InputMask
          name={name}
          mask={props.mask}
          value={props.onChange ? props.value : field.value}
          onChange={inputChangeHandler}
          className={classNames(form_element, { [inputClassName]: !!inputClassName })}
        />
      );
    } else if (type === 'password') {
      return (
        <>
          <input
            name={name}
            type={visible ? 'text' : 'password'}
            placeholder={placeholder}
            value={props.onChange ? props.value : field.value}
            disabled={disabled}
            autoComplete={props.autocomplete}
            onChange={inputChangeHandler}
            className={classNames(form_element, { [inputClassName]: !!inputClassName })}
          />
          <Icon
            icon={classNames('icon-eye', styles.icon, visible ? styles.icon_visible : styles.icon_close)}
            onClick={toggleVisibleClickHandler}
            size={Size.LARGE}
            className={classNames(inputClassName)}
          />
        </>
      );
    } else {
      return (
        <input
          name={name}
          type={type}
          placeholder={placeholder}
          value={props.onChange ? props.value : field.value}
          disabled={disabled}
          autoComplete={props.autocomplete}
          onChange={inputChangeHandler}
          className={classNames(form_element, { [inputClassName]: !!inputClassName })}
        />
      );
    }
  }; 

  return (
    <FieldWrapper
      size={props.size ? props.size : Size.BIG}
      {...props}
      errors={props.errors || meta.error}
      wrapperClassName={wrapperClassName}
    >
      <label className={classNames(input_wrapper, { 'no-min': props.noMin }, labelClassName)}>
        {renderInput()}
        {!!meta.error && meta.touched && <Icon icon="error" className={styles.icon} />}
      </label>
    </FieldWrapper>
  );
});
